/**
 * Global Search Overlay Animations
 *
 * Animation definitions for the global search dropdown overlay.
 * Follows the same pattern as task-animations.ts.
 */

import {
  trigger,
  style,
  transition,
  animate,
  AnimationTriggerMetadata
} from '@angular/animations';

/**
 * Overlay slide-down animation
 *
 * Enters from slightly above with fade-in; leaves with reverse.
 * Duration: 200ms enter, 150ms leave
 *
 * Usage: <div [@overlaySlideDown]>
 */
export const overlaySlideDownAnimation: AnimationTriggerMetadata = trigger('overlaySlideDown', [
  transition(':enter', [
    style({ opacity: 0, transform: 'translateY(-8px)' }),
    animate('200ms ease-out', style({ opacity: 1, transform: 'translateY(0)' }))
  ]),
  transition(':leave', [
    animate('150ms ease-in', style({ opacity: 0, transform: 'translateY(-8px)' }))
  ])
]);

/**
 * Backdrop fade animation
 *
 * Simple opacity fade for the background scrim.
 * Duration: 150ms enter, 100ms leave
 *
 * Usage: <div [@backdropFade]>
 */
export const backdropFadeAnimation: AnimationTriggerMetadata = trigger('backdropFade', [
  transition(':enter', [
    style({ opacity: 0 }),
    animate('150ms ease-out', style({ opacity: 1 }))
  ]),
  transition(':leave', [
    animate('100ms ease-in', style({ opacity: 0 }))
  ])
]);

/**
 * Stagger group animation for result items
 *
 * Each result group fades in from slightly below.
 * Duration: 150ms ease-out
 *
 * Usage: <div [@staggerGroup]>
 */
export const staggerGroupAnimation: AnimationTriggerMetadata = trigger('staggerGroup', [
  transition(':enter', [
    style({ opacity: 0, transform: 'translateY(6px)' }),
    animate('150ms ease-out', style({ opacity: 1, transform: 'translateY(0)' }))
  ])
]);

/**
 * Export all animations as a single array for component registration.
 *
 * Usage in @Component decorator:
 * @Component({ animations: globalSearchAnimations })
 */
export const globalSearchAnimations: AnimationTriggerMetadata[] = [
  overlaySlideDownAnimation,
  backdropFadeAnimation,
  staggerGroupAnimation
];
